import plusIcon from "../assets/plusOrangeIcon.png";
import equalIcon from "../assets/equalIcon.png";
import { useState, useEffect } from "react";
import usePrevisionsStore from "../store/previsionsStore";

const EditTaxesDetails = ({ onValuesChange, currentValues }) => {
  const {
    seaFreight: seaFreightValue = 0,
    otherTaxes: otherTaxesValue = 0,
    landShipping: landShippingValue = 0,
    cmvValue: cmvValue = 0,
    prevision,
    setPrevision,
  } = currentValues;

  const formattedSeaFreight = seaFreightValue.toString().replace(".", ",");
  const formattedOtherTaxes = otherTaxesValue.toString().replace(".", ",");
  const formattedLandShipping = landShippingValue.toString().replace(".", ",");
  const formattedCmvValue = cmvValue.toString().replace(".", ",");

  useEffect(() => {
    setCmvValue(formattedCmvValue);
    setOtherTaxes(formattedOtherTaxes);
    setLandShipping(formattedLandShipping);
    setSeaFreight(formattedSeaFreight);
  }, [
    formattedSeaFreight,
    formattedOtherTaxes,
    formattedLandShipping,
    formattedCmvValue,
  ]);

  const [cmv, setCmvValue] = useState(Number(formattedCmvValue) || "");
  const [otherTaxes, setOtherTaxes] = useState(
    Number(formattedOtherTaxes) || ""
  );
  const [seaFreight, setSeaFreight] = useState(
    Number(formattedSeaFreight) || ""
  );
  const [landShipping, setLandShipping] = useState(
    Number(formattedLandShipping) || ""
  );
  const [valueCIF, setValueCIF] = useState("");

  const { previsions, getAllPrevisions } = usePrevisionsStore();

  useEffect(() => {
    getAllPrevisions();
  }, [getAllPrevisions]);

  useEffect(() => {
    if (currentValues?.prevision && previsions.length > 0) {
      const selectedPrevision = previsions.find(
        (item) => item.name_previsions === currentValues.prevision
      );
      if (selectedPrevision) {
        setPrevision(selectedPrevision.name_previsions);
      }
    }
  }, [currentValues, previsions]);

  useEffect(() => {
    onValuesChange({
      forbValue: cmv,
      otherTaxes,
      seaFreight,
      landShipping,
      valueCIF,
    });
  }, [cmv, otherTaxes, seaFreight, landShipping, valueCIF, onValuesChange]);

  useEffect(() => {
    setValueCIF(
      "$" + (parseFloat(cmv) + parseFloat(seaFreight) + parseFloat(otherTaxes))
    );
  }, [cmv, seaFreight, otherTaxes]);

  const formatToUSD = (value) => {
    if (!value) return "";
    const numberValue = Number(value) / 100;
    return numberValue.toLocaleString("pt-BR", {
      style: "currency",
      currency: "USD",
    });
  };
  const formatCurrencyInput = (e) => {
    const inputValue = e.target.value.replace(/\D/g, "");
    const formattedValue = formatToUSD(inputValue);
    return formattedValue;
  };

  const handleChangeSeaFreight = (e) => {
    const formatedValueNumber = formatCurrencyInput(e);
    setSeaFreight(formatedValueNumber);
  };

  const handleForbValue = (e) => {
    const formatedValueNumber = formatCurrencyInput(e);
    setCmvValue(formatedValueNumber);
  };

  const handleChangeOtherTaxes = (e) => {
    const formatedValueNumber = formatCurrencyInput(e);
    setOtherTaxes(formatedValueNumber);
  };

  const handleChangeLandShipping = (e) => {
    const formatedValueNumber = formatCurrencyInput(e);
    setLandShipping(formatedValueNumber);
  };

  return (
    <div className=" bg-extraLightGray p-6 text-boldGray opacity-90 mt-4 rounded-md">
      <div className="flex pb-6 justify-around items-center border-b border-lightGray">
        <div className="w-[20%]">
          <div className="flex justify-center">
            <span className="text-primary uppercase font-bold mb-2 md:text-xs lg:text-base text-center">
              CMV
            </span>
          </div>
          <div className="rounded-md shadow-md bg-white flex justify-center py-2 w-[80%] mx-auto ">
            <input
              required
              className="w-full text-center outline-none"
              placeholder="$ 0,00"
              value={cmv}
              onChange={handleForbValue}
            />
          </div>
        </div>
        <div className="flex items-end justify-center h-[40px]">
          <img src={plusIcon} alt="ícone de soma" />
        </div>
        <div className="w-[20%]">
          <div className="flex justify-center">
            <span className="text-primary uppercase font-bold mb-2 md:text-xs lg:text-base text-center">
              Frete Marítimo
            </span>
          </div>
          <div className="rounded-md shadow-md bg-white flex justify-center py-2 w-[80%] mx-auto">
            <input
              required
              className="w-full text-center outline-none"
              placeholder="$ 0,00"
              value={seaFreight}
              onChange={handleChangeSeaFreight}
            />
          </div>
        </div>
        <div className="flex items-end justify-center h-[40px]">
          <img src={plusIcon} alt="ícone de soma" />
        </div>

        <div className="w-[20%]">
          <div className="flex justify-center">
            <span className="text-primary uppercase font-bold mb-2 md:text-xs lg:text-base text-center">
              Outras Taxas
            </span>
          </div>
          <div className="rounded-md shadow-md bg-white flex justify-center py-2 w-[80%] mx-auto">
            <input
              required
              className="w-full text-center outline-none"
              placeholder="$ 0,00"
              value={otherTaxes}
              onChange={handleChangeOtherTaxes}
            />
          </div>
        </div>
        <div className="flex items-end justify-center h-[40px]">
          <img src={equalIcon} alt="ícone de soma" />
        </div>
        <div className="w-[20%]">
          <div className="flex justify-center">
            <span className="text-primary uppercase font-bold mb-2 md:text-xs lg:text-base text-center">
              Valor CIF
            </span>
          </div>
          <div className="rounded-md shadow-md bg-white flex justify-center w-[80%] mx-auto">
            <input
              required
              className="w-full text-center outline-none h-[40px]"
              placeholder="$ 0,00"
              value={valueCIF}
              disabled
            />
          </div>
        </div>
      </div>
      <div className="grid md:grid-cols-1 lg:grid-cols-2 lg:justify-around mt-6">
        <div className="md:col-span-2">
          <div className="md:w-full lg:w-full"></div>
        </div>

        <div className="md:col-span-2">
          <div className="md:w-full lg:w-full">
            <div className="justify-center flex mb-4 mt-4">
              <span className="text-primary uppercase font-bold">Previsão</span>
            </div>
            <div className="uppercase col-span-2">
              <div className="flex justify-start mb-4 col-span-2">
                <div className="flex ml-6">
                  <span className="font-bold text-primary w-[60%] col-span-2  items-center flex mr-[20px]  md:text-base lg:text-sm xl:text-sm 2xl:text-base">
                    Escolha a previsão
                  </span>
                  <div className="rounded-md bg-lightGray text-center ">
                    <select
                      className="text-center outline-none bg-transparent py-2 lg:min-w-[140px] xl:min-w-[180px] 2xl:min-w-[450px]"
                      value={prevision || 0}
                      onChange={(e) => setPrevision(e.target.value)}
                      required
                    >
                      <option value="" disabled>
                        Selecione a previsão
                      </option>
                      {previsions.map((previsions, index) => (
                        <option key={index} value={previsions.name_previsions}>
                          {previsions.name_previsions}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="md:w-full lg:w-full">
            <div className="justify-center flex mb-4 mt-4">
              <span className="text-primary uppercase font-bold">
                Logística
              </span>
            </div>
            <div className="uppercase col-span-2">
              <div className="flex justify-start mb-4 col-span-2">
                <div className="flex ml-6">
                  <span className="font-bold text-primary w-[60%] col-span-2  items-center flex mr-[20px]  md:text-base lg:text-sm xl:text-sm 2xl:text-base">
                    Frete Terrestre
                  </span>
                  <div className="rounded-md bg-lightGray text-center ">
                    <input
                      required
                      className=" text-center outline-none bg-transparent py-2 lg:max-w-[140px] xl:max-w-[180px] 2xl:max-w-[207px] "
                      placeholder="$ 0,00"
                      value={landShipping}
                      onChange={handleChangeLandShipping}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTaxesDetails;
